import React from 'react';
import propTypes from 'prop-types';
import { cn } from 'lib/utils';

export default function BadgeWithIcon({ icon, children, className }) {
  return (
    <div
      className={cn(
        'grid grid-cols-[auto_1fr] gap-2 w-full bg-white p-2 pt-2.5 rounded-xl items-start',
        className
      )}
    >
      <div className='col-start-1 pt-[2.5px]'>{icon}</div>
      <div className='min-w-0 text-left col-start-2 flex flex-col gap-1 [&_p]:m-0'>
        {children}
      </div>
    </div>
  );
}

BadgeWithIcon.propTypes = {
  icon: propTypes.node.isRequired,
  children: propTypes.node.isRequired,
  className: propTypes.string
};
